import Companies from './Companies';

export default Companies;
